<template>
  <input id="autocomplete" class="input_container" ref="autocompleteInput" :placeholder="placeholder" :value="value"
    :style="customStyle" @focus="initAutocomplete" :disabled="disabled" @click="undoDisabled" />
</template>

<script>
import VueMeta from "vue-meta";
import Vue from "vue";

export default {
  props: {
    locationDetails: {
      required: true,
    },
    customStyle: {},
    placeholder: {},
    country: { type: String },
    value: { type: String },
  },
  data() {
    return {
      autocomplete: null,
      disabled: false
    };
  },

  mounted() {
    // Ensure that the Google Maps API is loaded before initializing the Autocomplete
    if (
      typeof window.google !== "undefined" &&
      typeof window.google.maps !== "undefined"
    ) {
      this.initAutocomplete();
    } else {
      console.error("Google Maps API not loaded.");
    }
  },
  methods: {
    undoDisabled() {
      this.disabled = false
      this.$refs.autocompleteInput.disabled = false
    },
    initAutocomplete() {
      this.autocomplete = new window.google.maps.places.Autocomplete(
        this.$refs.autocompleteInput,
        {
          componentRestrictions: {
            country: this.country, // Set the country restriction here
          },
        }
      );

      this.autocomplete.addListener("place_changed", this.handlePlaceChanged);
    },
    handlePlaceChanged() {
      const selectedPlace = this.autocomplete.getPlace();
      if (selectedPlace?.geometry && selectedPlace?.geometry?.location) {
        this.locationDetails(selectedPlace);
      }
    },
  },
  watch: {
    value(newValue) {
      this.$refs.autocompleteInput.value = newValue; // Update inputValue when prop changes
    }
  },

  metaInfo() {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_AUTOCOMPLETE_API_KEY}&libraries=places&callback=initMap`,
          async: true,
        },
      ],
    };
  },
  created() {
    // Make sure to add the VueMeta plugin
    Vue.use(VueMeta, {
      refreshOnceOnNavigation: true,
    });
  },
};
</script>

<style scoped>
.input_container {
  width: 400px;
  padding: 0.3em;
  border: 1px solid teal;
  background: none !important;
}
</style>
